import { writable, get } from 'svelte/store';
import type { SanityReference, SanityDocument } from '$lib/sanity/schemas';

type ResolvedReferencesRegistry = Record<string, SanityDocument>;

const createReferencesStore = () => {
  const store = writable<ResolvedReferencesRegistry>({});

  function dereference<T extends SanityDocument>(reference: SanityReference | T): T | null {
    let document;

    if (reference._type === 'reference') {
      document = get(store)[(reference as SanityReference)._ref];
    } else {
      document = reference as T;
    }

    if (!document) {
      return null;
    }

    return document as T;
  }

  function add<T extends SanityDocument>(records: T | T[]) {
    store.update((currentState) => {
      [records].flat().forEach((record) => (currentState[record._id] = record));

      return currentState;
    });
  }

  return {
    ...store,
    add,
    dereference
  };
};

export const referencesStore = createReferencesStore();
